import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import BlankLayout from "layouts/Blank.js";

const history = createBrowserHistory();

ReactDOM.render(
  <BrowserRouter history={history}>
    <Switch>
      <Route path="/admin" render={props => <AdminLayout {...props} />} />
      <Route path="/auth" render={props => <AuthLayout {...props} />} />
      <Route path="/blank" render={props => <BlankLayout {...props} />} />
      <Redirect from="/" to="/blank/FechamentoPeriodo" />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
